// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/prop-types */
import clsx from 'clsx';
import React from 'react';

export default function CircleButtons({
	numberOfButtons,
	clickHandler,
	center,
}) {
	return (
		<div className="flex justify-center">
			{numberOfButtons.map((_, index) => (
				<button
					type="button"
					key={index.id}
					aria-label={`Go to course ${index}`}
					className={clsx(
						'w-3 h-3 rounded-full mx-1',
						index === center ? 'bg-blue-500' : 'bg-brand-pale-500'
					)}
					onClick={() => clickHandler(index)}
				/>
			))}
		</div>
	);
}
